import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { IoClose as Close } from 'react-icons/io5';
import { BsTrash3 as TrashIcon } from 'react-icons/bs';
import { FiAlertTriangle, FiUser } from 'react-icons/fi';
import './DeleteNameCardForm.scss';

export default function DeleteNameCardForm(props) {
    const [deleting, setDeleting] = useState(false);

    const className = 'deleteNameCardForm';

    const personName =
        props?.item?.name ||
        props?.item?.fullName ||
        'Unnamed contact';
    const handleDelete = async () => {
        if (deleting) return;

        setDeleting(true);

        try {
            await props?.deleteNameCard?.();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={deleting ? undefined : props.closePopup}
            maxWidth="sm"
            fullWidth
            className={className}
            PaperProps={{
                className: `${className}__paper`,
            }}
        >
            {/* Header */}
            <DialogTitle className={`${className}__header`}>
                <Box className={`${className}__header-content`}>
                    <Box className={`${className}__icon`}>
                        <TrashIcon />
                    </Box>

                    <Box className={`${className}__heading`}>
                        <Typography
                            className={`${className}__eyebrow`}
                        >
                            Delete contact
                        </Typography>

                        <Typography
                            className={`${className}__title`}
                        >
                            Delete this contact ?
                        </Typography>
                    </Box>
                </Box>

                <IconButton
                    onClick={props.closePopup}
                    disabled={deleting}
                    className={`${className}__close`}
                    size="small"
                    aria-label="Close"
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent className={`${className}__content`}>
                {/* Contact */}
                <Box className={`${className}__contact-card`}>
                    <Box className={`${className}__avatar`}>
                        <FiUser />
                    </Box>

                    <Box className={`${className}__contact-info`}>
                        <Typography
                            className={`${className}__contact-label`}
                        >
                            Contact
                        </Typography>

                        <Typography
                            className={`${className}__contact-name`}
                            title={personName}
                        >
                            {personName}
                        </Typography>
                    </Box>
                </Box>

                {/* Warning */}
                <Box className={`${className}__warning`}>
                    <Box className={`${className}__warning-icon`}>
                        <FiAlertTriangle />
                    </Box>

                    <Box className={`${className}__warning-content`}>
                        <Typography
                            className={`${className}__warning-title`}
                        >
                            This action cannot be undone
                        </Typography>

                        <Typography
                            className={`${className}__warning-text`}
                        >
                            Deleting this will permanently remove from your account.
                        </Typography>
                    </Box>
                </Box>

                <Typography
                    className={`${className}__confirmation`}
                >
                    Are you sure you want to delete {' '}
                    <strong>{personName} </strong>?
                </Typography>
            </DialogContent>

            {/* Footer */}
            <DialogActions className={`${className}__footer`}>
                <Button
                    onClick={props.closePopup}
                    disabled={deleting}
                    variant="text"
                    className={`${className}__cancel`}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    color="error"
                    startIcon={
                        deleting ? (
                            <CircularProgress
                                size={17}
                                color="inherit"
                            />
                        ) : (
                            <TrashIcon />
                        )
                    }
                    onClick={handleDelete}
                    disabled={deleting}
                    className={`${className}__delete`}
                >
                    {deleting ? 'Deleting...' : 'Delete Contact'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
